// AUTO GENERATED FILE - Changes WILL be lost.
// ro-RO - used as 'ro' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Bilet",
  "product.last60-row-single": "NBA Ultimele 60 de meciuri unice",
  "product.sb-english-single": "Engleză Soccerbet meci unic",
  "product.sb-italian-single": "Italian Soccerbet Single Match",
  "product.sb-greek-single": "Meci unic fotbal grecesc",
  "product.sb-english-league": "Liga engleză Soccerbet",
  "product.sb-italian-league": "Liga de fotbal italiană",
  "product.sb-greek-league": "Liga de fotbal greacă",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Plasați pariul",
  "betslip.clear": "Curata tot",
  "betslip.clearResult": "Clar",
  "betslip.noSelections": "Adăugați selecții pentru a începe pariurile",
  "betslip.notLoggedIn": "Autentifică-te pentru a începe pariurile",
  "betslip.refresh": "Refresh",
  "betslip.totalStake": "Miză totală",
  "betslip.noHistoryData": "Nu sunt disponibile informații despre pariu",
  "betslip.openBets": "Pariuri deschise",
  "betslip.betHistory": "Istoria pariului",
  "betslip.betHistoryWon": "Câștigat",
  "betslip.betHistoryLost": "Pierdut",
  "loading.loading": "Se încarcă",
  "loading.account": "Se încarcă contul",
  "loading.league": "Se încarcă liga",
  "loading.gameweeks": "Încărcarea săptămânilor de joc",
  "loading.markets": "Încărcarea piețelor",
  "loading.bethistory": "Se încarcă istoricul pariului",
  "login.loginRequired": "Autentificare obligatorie",
  "login.loginToBet": "Vă rugăm să vă autentificați pentru a începe pariurile",
  "navigation.back": "Înapoi",
  "navigation.close": "Închide",
  "video.liveStreamAvailable": "Streaming live disponibil",
  "video.logInToWatch": "Vă rugăm să vă conectați pentru a viziona",
  "error.error": "Eroare",
  "error.404": "Pagina nu a fost găsita",
  "error.gameLaunchFailed": "Imposibil de lansat jocul",
  "error.unknownErrorCode": "Eroare necunoscută: {code}",
  "error.minUnitStakeLimitExceeded": "Miza minimă este {limit}",
  "error.maxUnitStakeLimitExceeded": "Miza maximă este {limit}",
  "error.minTotalStakeLimitExceeded": "Miza totală minimă este {limit}",
  "error.maxTotalStakeLimitExceeded": "Miza totală maximă este {limit}",
  "error.stakeInvalidMultiple": "Miza trebuie să fie un multiplu de {multiple}",
  "error.notPlaced": "Nu este plasat",
  "error.wagerDisallowed": "Pariul a fost anulat",
  "error.errorEventIsOff": "Evenimentul a început",
  "wagerType.Singles": "Simplu",
  "wagerType.Doubles": "Dubluri",
  "wagerType.Trebles": "Treble",
  "wagerType.Accumulator": "Acumulator",
  "wagerType.Perm 4-Folds": "Perm 4-ori",
  "wagerType.Perm 5-Folds": "Perm 5-ori",
  "wagerType.Perm 6-Folds": "Perm 6-ori",
  "wagerType.Perm 7-Folds": "Perm 7-ori",
  "wagerType.Perm 8-Folds": "Perm 8 ori",
  "wagerType.Perm 9-Folds": "Perm 9-ori",
  "error.excess_bets": "Numărul maxim de meciuri pe bilet este {limit}. Va rog ștergeți o selecție",
  "product.sb-turkish-league": "Liga Turciei",
  "error.minBetslipLimitExceeded": "Suma minimă de pariere este {limit}",
  "error.maxBetslipLimitExceeded": "Suma maximă de pariere este {limit}",
  "error.exceededMaxPayout": "Câștigul maxim potential este {limit} ; vă rugăm micșorați miza",
  "betslip.potentialReturns": "Câștig posibil",
  "betslip.taxDisclaimer": "Toate câștigurile nete sunt impozitate la soluționarea pariului. Valoarea taxei va fi calculată în funcție de câștigurile potențiale ale pariului.",
  "error.maintenanceEnabled": "Serverul este în prezent în curs de mentenanță",
  "error.internalError": "Eroare internă",
  "error.invalidSession": "Sesiunea este invalidă",
  "error.accountDisabled": "Contul este dezactivat",
  "error.invalidPlayerID": "Player ID invalid",
  "error.insufficientBalance": "Fonduri insuficiente",
  "error.configError": "Eroare de configurare",
  "error.betPlaceFailed": "Eroare la plasarea pariului",
  "error.invalidProductID": "ID Produs invalid",
  "error.playerReachedGamingLimits": "Jucătorul a atins limita de pariere responsabil",
  "error.gameCycleDoesNotExist": "Runda nu există",
  "error.betAmountLimitExceeded": "Limita de câștig pentru jucători neverificați a fost depășită",
  "betslip.netStake": "Miza netă",
  "betslip.tax": "Taxă",
  "error.badReturns": "Randamentele potențiale sunt mai mici decât miza brută",
  "betslip.taxDisclaimerPoland": "Câștigurile vor fi reduse cu 10% pentru sume mai mari de 2.280 PLN.",
  "error.incompatibleVersion": "Versiune de aplicație neacceptată. Vă rugăm să faceți upgrade.",
  "product.iihf-row-single": "Campionatul Mondial IIHF",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Întoarcerea la jucător",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "RTP-ul mediu pentru acest joc este {limit}.",
  "error.betslipContainsInvalidOptions": "Buletinul de pariuri conține opțiuni invalide cu roșu",
  "product.sb-scottish-single": "Scottish Soccerbet Single Metch",
  "product.sb-spanish-single": "Pariul de fotbal spaniol un singur meci",
  "product.sb-spanish-league": "Liga spaniolă Soccerbet",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Pariuri inchise",
  "playtime": "Timp de joaca",
  "gameId": "ID-ul jocului",
  "noGames": "Nu sunt jocuri disponibile. Verificați din nou în curând.",
  "Home": "Acasă",
  "Away": "Deplasare",
  "Visitor": "Oaspeți",
  "rules": "Reguli",
  "soccerbet.gameWeek": "SAPTĂMÂNĂ",
  "soccerbet.noGameWeeks": "Nu sunt disponibile săptămâni de joc. Verificați din nou în curând.",
  "soccerbet.league": "Clasamentul Ligii",
  "soccerbet.table.name": "Nume",
  "soccerbet.table.won": "V",
  "soccerbet.table.drawn": "E",
  "soccerbet.table.lost": "Î",
  "soccerbet.table.points": "PT",
  "abbr.event.Both Teams To Score": "GG",
  "event.Both Teams To Score": "Ambele echipe să înscrie",
  "event.Over / Under": "Peste/Sub",
  "event.Double Chance": "Șansă dublă",
  "event.Match Result": "Rezultatul meciului",
  "event.Exact Goals": "Număr goluri exact",
  "event.Correct Score": "Scor corect",
  "event.Match Result Both Score": "Rezultatul meciului & ambele marchează",
  "event.Result Und/Over 1.5 Total Goals": "Rezultat Peste/Sub 1.5 Goluri",
  "event.Result Und/Over 2.5 Total Goals": "Rezultat Peste/Sub 2.5 Goluri",
  "event.Under Over 1.5 Total Goals": "Peste/Sub 1.5 Goluri",
  "event.Under Over 2.5 Total Goals": "Peste/Sub 2.5 Goluri",
  "event.Under Over 3.5 Total Goals": "Peste/Sub 3.5 Goluri",
  "event.Under Over 4.5 Total Goals": "Peste/Sub 4.5 Goluri",
  "event.Total Goals 1 To 2": "Interval total goluri 1-2",
  "event.Total Goals 1 To 3": "Interval total goluri 1-3",
  "event.Total Goals 1 To 4": "Interval total goluri 1-4",
  "event.Total Goals 2 To 3": "Interval total goluri 2-3",
  "event.Total Goals 2 To 4": "Interval total goluri 2-4",
  "event.Under Over 1.5 Home Goals": "Peste/sub 1.5 goluri echipa gazdă",
  "event.Under Over 1.5 Away Goals": "Peste/sub 1.5 goluri echipa oaspete",
  "event.Home Team Exact Goals": "Număr goluri exact ale echipei gazdă",
  "event.Away Team Exact Goals": "Număr goluri exact ale echipei oaspete",
  "selection.Yes": "Da",
  "selection.No": "Nu",
  "selection.1+G": "1&G",
  "selection.1+Ng": "1&Ng",
  "selection.X+G": "X&G",
  "selection.X+Ng": "X&Ng",
  "selection.2+G": "2&G",
  "selection.2+Ng": "2&Ng",
  "selection.1+Yes": "1&Da",
  "selection.1+No": "1&Nu",
  "selection.X+Yes": "X&Da",
  "selection.X+No": "X&Nu",
  "selection.2+Yes": "2&Da",
  "selection.2+No": "2&Nu",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "Sub",
  "selection.O": "Peste",
  "selection.1+O": "1&Peste",
  "selection.X+O": "X&Peste",
  "selection.2+O": "2&Peste",
  "selection.1+U": "1&Sub",
  "selection.X+U": "X&Sub",
  "selection.2+U": "2&Sub",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "PESTE",
  "selection.Under": "SUB",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KAIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "ANUNȚ. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NOT",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Athletic Bilbao",
  "sb-spanish.team.ATM": "Atletico Madrid",
  "sb-spanish.team.FCB": "Barcelona",
  "sb-spanish.team.CAD": "Cadiz",
  "sb-spanish.team.CLV": "Celta Vigo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Granada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Mallorca",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madrid",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sevilla",
  "sb-spanish.team.VAL": "Valencia",
  "sb-spanish.team.VIL": "Villarreal",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "Celtic",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "Inimi",
  "sb-scottish.team.HIB": "Hiberian",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangers",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE"
}
